
import WTooltip from '../w-tooltip/w-tooltip.vue'

export default {
  components: {
    WTooltip,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    infoDialogTitle: {
      type: String,
      default: null,
    },
    infoDialogText: {
      type: String,
      default: null,
    },
    tooltipText: {
      type: String,
      default: null,
    },
    justify: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: 'ribbon',
      validator: (value) =>
        ['ribbon', 'no-ribbon', 'panel'].includes(value.toLowerCase()),
    },
  },

  computed: {
    useTooltip() {
      return this.tooltipText && !this.infoDialogTitle
    },

    useInfoDialog() {
      return this.infoDialogTitle !== null && this.infoDialogText !== null
    },
  },

  methods: {
    hasValue() {
      return (
        this.$slots.default &&
        this.$slots.default.some((item) => !!item.tag || item.text.match(/\S/))
      )
    },

    openInfoDialog() {
      this.$store.dispatch('infoDialog/showTextContent', {
        title: this.infoDialogTitle,
        text: this.infoDialogText,
      })
    },
  },
}
